/* eslint-disable no-undef */
import './index.scss';

import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import Modal from '../../containers/modal';
import CardMeal from '../../components/new-card';
import { SessionStorage } from '../../burger-king-lib/utils/storage.web';
import { LocalSessionKey } from '../../burger-king-lib/constants/app-constants';
import { getProductAddonDetail } from '../../burger-king-lib/redux/productListing/actions';

import { getProductCategoryPayload } from '../../payload-handling/product-listing';

import { getCategoryImage } from '../../utils/services';
import { addToCartPayload } from '../../payload-handling/cart';
import Loader from '../../components/loader-spin';
import Button from '../../components/button';

class ProductDetailPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCollapse: true,
      content: props.content,
      upgradeToMeal: [],
      categories: [],
      activeUpgradeToMeal: [],
      activeUpgradeToMealIndex: '',
      addonsList: [],
      addOnsActiveContent: [],
      addOnsActiveTabIndex: 0,
      customize_quantity: this.setInitialQuantity(),
      showLoader: false,
      showAlertModal: false,
      onRestrict: false
    };
  }

  componentDidMount() {
    const { addonsList } = this.state;
    const {
      isToGetAddonDetail,
      content,
      productListingData,
      title
    } = this.props;
    const { getProductAddonDetailData, setInitial, getAllAddonsData } = this;
    if (isToGetAddonDetail) {
      getProductAddonDetailData();
    } else {
      setInitial(content);
    }

    if (
      productListingData &&
      productListingData.getAllAddons &&
      productListingData.getAllAddons.content &&
      productListingData.getAllAddons.content.length
    ) {
    } else {
      this.setState({ showLoader: true });
    }
  }
  componentDidUpdate(prevProps) {
    const { productListingData } = this.props;
    if (
      productListingData &&
      productListingData !== prevProps.productListingData &&
      productListingData.productAddonDetail &&
      productListingData.productAddonDetail !==
        prevProps.productListingData.productAddonDetail
    ) {
      if (
        productListingData.productAddonDetail.message &&
        productListingData.productAddonDetail.content !==
          prevProps.productListingData.productAddonDetail.content
      ) {
        this.toggleLoader();
      }
      if (productListingData.productAddonDetail.content) {
        this.setContent(productListingData.productAddonDetail.content);
      }
    }

    if (
      productListingData &&
      productListingData !== prevProps.productListingData &&
      productListingData.getAllAddons &&
      productListingData.getAllAddons !==
        prevProps.productListingData.getAllAddons
    ) {
      if (productListingData.getAllAddons.message) {
        this.toggleLoader();
      }
    }
  }

  componentWillUnmount() {
    this.resetQuantityCheck();
  }

  toggleLoader = () => {
    this.setState({ showLoader: false });
  };

  setContent = data => {
    const firstVarient = data[0]?.variant_category?.variants?.[0];
    this.setData(data);
    if (!this.props.select) {
      this.props.selectedFun(firstVarient?.entity_id, firstVarient);
    } else {
      this.props.selectedFun(this.props.select, this.props.selectedVariant);
    }
  };

  setData = data => {
    const categories =
      data?.[0]?.variant_category?.variants?.map(item => ({ ...item })) || [];
    this.setState({
      categories,
      wholeData: data
    });
  };

  getProductAddonDetailData = () => {
    const { getProductAddonDetailData, isFrom, content } = this.props;
    let { entity_id, product_entity_id } = content;
    const id = isFrom === 'cart' ? product_entity_id : entity_id;
    const payload = getProductCategoryPayload(id);
    // console.log({ props: this.props, payload }, ' flag1234 ');
    this.setState({ showLoader: true });
    getProductAddonDetailData(payload);
  };

  setInitialQuantity = () => {
    const { cartAddedData } = this.props;
    if (cartAddedData && cartAddedData.quantity) return cartAddedData.quantity;
    return 1;
  };

  setInitial = content => {
    const { cartAddedData, productListingData } = this.props;
    const { variant_category } = content;
    const [FirEl] = variant_category;
    const { variants } = FirEl;
    if (!(cartAddedData && cartAddedData.product_id)) {
      variants[0].custom_price = variants[0].price;
    }

    if (cartAddedData && cartAddedData.product_id) {
      variants[0].custom_price = cartAddedData.item_price;
    }

    this.setState({
      content
    });
  };

  setUpgradeToMeal = addons => {
    if (addons && addons.length) {
      const upgradeToMeal = addons.filter(
        data => data.name === 'Make it a COMBO'
      );
      if (upgradeToMeal && upgradeToMeal[0]) {
        const [FirEl] = upgradeToMeal;
        const { products } = FirEl;
        return products;
      }
    }
    return [];
  };

  setInitialActiveUpgradeToMeal = upgradeToMeal => {
    const { cartAddedData } = this.props;
    if (upgradeToMeal && upgradeToMeal.length) {
      let activeUpgradeToMeal = {};
      if (cartAddedData && cartAddedData.is_combo) {
        const { addons } = cartAddedData;
        const product_addons = !addons ? [] : Object.values(addons);
        if (product_addons && product_addons.length) {
          activeUpgradeToMeal = {};
          const filtered = upgradeToMeal.filter(
            item => item.entity_id === product_addons[0].entity_id
          );
          activeUpgradeToMeal = filtered.length > 0 ? filtered[0] : {};
        }
      }
      return activeUpgradeToMeal;
    }
    return '';
  };

  setInitialActiveUpgradeToMealIndex = upgradeToMeal => {
    const { cartAddedData } = this.props;
    this.index = '';
    if (cartAddedData && cartAddedData.is_combo) {
      const { addons } = cartAddedData;
      const product_addons = !addons ? [] : Object.values(addons);
      if (product_addons && product_addons.length) {
        upgradeToMeal.filter((data, index) => {
          if (data.name == product_addons[0].product_name) this.index = index;
          return data;
        }, this);
      }
    }
    return this.index;
  };

  setInitialAddonActiveContent = (variants, addonsList) => {
    const { cartAddedData } = this.props;

    if (
      cartAddedData &&
      cartAddedData.product_addons &&
      cartAddedData.product_addons.length
    ) {
      const addonsData = addonsList;

      if (addonsData && addonsData.length) {
        addonsData.map(addonData => {
          const { products } = addonData;
          products.map(prodData => {
            const { id } = prodData;

            const filterData = cartAddedData.product_addons.filter(
              cartData => cartData.addon_id === id
            );
            if (filterData && filterData.length && filterData[0].quantity) {
              prodData.quantity = filterData[0].quantity;
            }
            return prodData;
          });
          return addonData;
        });
      }
      addonsList = addonsData;
    }

    if (addonsList) {
      const [FirElAddOn] = addonsList;
      return FirElAddOn;
    }
    return [];
  };

  toggleCollapse = () => {
    const { isCollapse } = this.state;
    this.setState({ isCollapse: !isCollapse });
  };

  upgradeMealToggle = (index, dd = []) => {
    const {
      content,
      activeUpgradeToMealIndex,
      upgradeToMeal: upgradeToMeal1
    } = this.state;
    const upgradeToMeal = dd.length > 0 ? dd : upgradeToMeal1;
    const { variant_category } = content;
    const variants = variant_category?.[0]?.variants;
    if (variants[0].custom_price == null) {
      variants[0].custom_price = variants[0].price; // Set custom_price to 0 if it's undefined or null
    }
    if (
      variants[0].custom_price &&
      variants[0].custom_price !== undefined &&
      activeUpgradeToMealIndex !== index &&
      upgradeToMeal.length > 0
    ) {
      if (Number.isInteger(activeUpgradeToMealIndex)) {
        variants[0].custom_price -=
          upgradeToMeal[activeUpgradeToMealIndex]?.variants.price;
      }
      variants[0].custom_price += upgradeToMeal[index].variants.price;
    }
    if (
      variants[0].custom_price &&
      variants[0].custom_price !== undefined &&
      activeUpgradeToMealIndex === index &&
      upgradeToMeal.length > 0
    ) {
      if (Number.isInteger(activeUpgradeToMealIndex)) {
        variants[0].custom_price -=
          upgradeToMeal[activeUpgradeToMealIndex].variants.price;
      }
    }
    this.setState({
      activeUpgradeToMealIndex: activeUpgradeToMealIndex === index ? '' : index,
      activeUpgradeToMeal:
        activeUpgradeToMealIndex === index ? {} : upgradeToMeal[index]
    });
  };

  addonsTabClick = (data, index) => {
    const { addonsList } = this.state;
    this.setState({
      addOnsActiveTabIndex: index,
      addOnsActiveContent: addonsList[index]
    });
  };

  addOnAddItemClickHandler = (isAdd, data, index, type, id) => {
    const { addOnsActiveContent, content, addonsList } = this.state;
    let active = addOnsActiveContent;
    if (type === 'list') {
      active = addonsList[id];
      this.addonsTabClick(data, id);
    }
    let { quantity } = data;
    const { variants } = data;
    const { price } = variants;
    const { min, max, products, is_product_based, name, entity_id } = active;
    if (isNaN(quantity)) quantity = 0;
    if (isAdd) {
      let selectedAddonQuantity = 0;

      products.map(item => {
        if (item.quantity) {
          selectedAddonQuantity += item.quantity;
        }
        return item;
      });
      if (selectedAddonQuantity >= max) {
        this.setState({
          showAlertModal: true,
          alertTextModal: `Getting too ${
            name === 'Cheese' ? 'Cheesy' : 'Patty'
          }!`
        });
      } else {
        quantity += 1;
        if (is_product_based)
          content.variant_category[0].variants[0].custom_price =
            Math.round(
              (content.variant_category[0].variants[0].custom_price + price) *
                100
            ) / 100;
      }
    } else if (!isAdd) {
      let selectedAddonQuantity = 0;
      products.map(item => {
        if (item.quantity) selectedAddonQuantity += item.quantity;
        return item;
      });

      if (selectedAddonQuantity <= min && min !== max)
        alert('Minimum limit required');
      else {
        quantity -= 1;
        if (is_product_based)
          content.variant_category[0].variants[0].custom_price =
            Math.round(
              (content.variant_category[0].variants[0].custom_price - price) *
                100
            ) / 100;
      }
    }

    data.quantity = quantity;
    products[index] = data;

    addOnsActiveContent.products = products;

    this.setState({ addOnsActiveContent });
  };

  onCloseHandler = () => {
    const { onCloseHandler } = this.props;
    onCloseHandler();
  };

  onCloseHandler1 = () => {
    const { onCloseHandler } = this.props;
    onCloseHandler(true, this.state.select);
  };

  addToCartClick = () => {
    const {
      addToCartPayload: addToCartPayloadProp,
      cartAddedData,
      theme
    } = this.props;
    const outletid = SessionStorage.get(LocalSessionKey.OUTLET_ID);
    const {
      content,
      customize_quantity,
      activeUpgradeToMeal,
      addonsList
    } = this.state;
    const { is_customise, variant_category, is_combo } = content;
    const [FirEl] = variant_category;
    const { variants } = FirEl;
    const [FirVarEl] = variants;
    const addonsPayload = [];
    let isAddonMinAdded = false;
    let isAddonMinString = '';
    const addonsProductPayload = [];
    if (outletid === 32236) this.setState({ onRestrict: true });
    else {
      if (addonsList && addonsList.length) {
        addonsList.forEach(addonsData => {
          const {
            products,
            name: category_name,
            entity_id: category_entity_id,
            min,
            name: addonName,
            is_product_based
          } = addonsData;
          let addedQuantity = 0;
          products.forEach(prodData => {
            const {
              quantity,
              entity_id,
              variants: prodVariants,
              id,
              name,
              image_urls
            } = prodData;
            const images = image_urls[0]?.images[0]?.image['1x'];
            const { price } = prodVariants;
            if (quantity && is_product_based) {
              addedQuantity += quantity;
              addonsPayload.push({
                category_name,
                category_entity_id,
                entity_id,
                id,
                quantity,
                name,
                price,
                images
              });
            } else if (quantity && !is_product_based) {
              const customise = {
                custom_price: price
              };
              // make it second args as dynamic
              const payload = addToCartPayload(
                theme,
                true,
                prodData,
                false,
                [],
                customise,
                quantity,
                false
              );
              addonsProductPayload.push(payload);
            }
          });
          if (addedQuantity !== min && min > 0) {
            isAddonMinAdded = true;
            if (isAddonMinString) isAddonMinString += ', ';
            isAddonMinString += ` ${min} item from ${addonName}`;
            return '';
          }
          return addonsData;
        });
      }
      if (is_combo && activeUpgradeToMeal && activeUpgradeToMeal.id) {
        const {
          entity_id,
          variants: upgradeVariant,
          id,
          name,
          image_urls
        } = activeUpgradeToMeal;
        const images = image_urls[0].images[0].image['1x'];
        const { price } = upgradeVariant;
        addonsPayload.push({
          category_name: 'Make it a COMBO',
          category_entity_id: 'AC::178909',
          entity_id,
          id,
          quantity: 1,
          name,
          price,
          images
        });
      }
      let customisePayload;
      if (is_customise) {
        const { name, id, custom_price } = FirVarEl;
        customisePayload = {
          customise_name: name,
          customise_id: id,
          custom_price
        };
      }
      if (!isAddonMinAdded) {
        if (this?.props?.cartAddedData) {
          content.product_id = this.props.cartAddedData.id;
        }
        if (addonsPayload.length) {
          content.is_customise = true;
        }
        let isADD;
        let { customize_quantity } = this.state;
        if (content.cart_quantity === customize_quantity) {
          isADD = true;
          content.is_customise = true;
          // }
        } else if (content.cart_quantity < customize_quantity) {
          isADD = true;
          content.cart_quantity += customize_quantity;
          content.is_customise = true;
          // }
        } else {
          isADD = true;
          content.cart_quantity -= customize_quantity;
          content.is_customise = true;
          // }
        }
        if (cartAddedData && cartAddedData.cart_item_id) {
          content.product_id = cartAddedData.cart_item_id;
        }
        addToCartPayloadProp(
          isADD,
          content,
          false,
          addonsPayload,
          customisePayload,
          customize_quantity,
          addonsProductPayload
        );
      } else {
        alert(`You need to select atleast ${isAddonMinString}`);
      }
    }
  };

  addItemClickHandler = (isAdd, data) => {
    const { cartAddedData } = this.props;
    if (cartAddedData && cartAddedData.is_from_offer) {
      return alert('Promotional Products cant be added');
    }
    if (isAdd && data && data.is_from_offer)
      return alert('Promotional Products cant be added');
    let { customize_quantity } = this.state;
    if (isAdd) {
      customize_quantity += 1;
    } else if (!isAdd && customize_quantity > 1) {
      customize_quantity -= 1;
    } else {
      alert('Please select atleast one! ');
    }
    this.setState({ customize_quantity });
  };

  resetQuantityCheck = () => {
    const { addonsList } = this.state;
    if (addonsList && addonsList.length) {
      addonsList.map(addonData => {
        const { products } = addonData;
        if (products && products.length) {
          products.map(prodData => {
            const { quantity } = prodData;
            if (quantity) prodData.quantity = 0;
            return prodData;
          });
        }
        return addonData;
      });
    }
  };

  okayClickHandler = () => {
    this.setState({ showAlertModal: false });
  };

  onokayClickHandler = () => {
    this.setState({ onRestrict: false });
  };

  render() {
    const { theme, isToGetAddonDetail, payloadForNextApi } = this.props;
    const { variant_name } = !!payloadForNextApi ? payloadForNextApi : '';
    const { addToCartClick } = this;
    const { innerWidth } = window;
    const {
      isCollapse,
      addOnsActiveContent,
      addOnsActiveTabIndex,
      activeUpgradeToMealIndex,
      content,
      customize_quantity,
      showLoader,
      upgradeToMeal,
      addonsList,
      showAlertModal,
      alertTextModal,
      onRestrict,
      wholeData
    } = this.state;
    const {
      variant_category,
      name,
      // image_urls,
      is_combo,
      description
    } = content;
    const imageUrls = this.props?.payloadForNextApi?.imageUrls;

    const { variants = {} } = variant_category?.[0] ?? {};
    const { custom_price = '', price = '', actual_price = '' } =
      variants?.[0] ?? {};

    const offerPrice =
      variant_category &&
      variant_category[0] &&
      variant_category[0].variants &&
      variant_category[0].variants[0] &&
      variant_category[0].variants[0].actual_price;
    let imageUrl = {
      '1x':
        process.env.REACT_APP_API_IMAGE_URL +
        '/products/AE/ml/1xmlPlaceholder134x67AddonSectionjpg',
      '2x':
        process.env.REACT_APP_API_IMAGE_URL +
        '/products/AE/ml/1xmlPlaceholder134x67AddonSectionjpg',
      '3x':
        process.env.REACT_APP_API_IMAGE_URL +
        '/products/AE/ml/1xmlPlaceholder134x67AddonSectionjpg'
    };

    let pdpImageUrl = {
      '1x':
        process.env.REACT_APP_API_IMAGE_URL +
        '/products/AE/ml/1xmlPlaceholder134x67AddonSectionjpg',
      '2x':
        process.env.REACT_APP_API_IMAGE_URL +
        '/products/AE/ml/1xmlPlaceholder134x67AddonSectionjpg',
      '3x':
        process.env.REACT_APP_API_IMAGE_URL +
        '/products/AE/ml/1xmlPlaceholder134x67AddonSectionjpg'
    };
    if (imageUrls && imageUrls.length) {
      imageUrl = getCategoryImage(imageUrls, 'pdpc');
      pdpImageUrl = getCategoryImage(imageUrls, 'pdpc');
    }

    // Rest of the code remains the same...
    const mealListItems =
      this.state.categories && this.state.categories.length > 0 ? (
        this.state.categories.map((item, index) => (
          <CardMeal
            {...item}
            idx={1}
            type="variants"
            selectedFun={this.props.selectedFun}
            select={this.props.select}
            theme={theme}
            item={item}
            index={index}
            key={index.toString()}
            activeIndex={activeUpgradeToMealIndex}
            toggleClick={this.upgradeMealToggle}
          />
        ))
      ) : (
        <h1>No Data</h1>
      );

    const footerDom = (
      // <div className="product-detail__meal-checkout">
      <div className="cardBlock">
        <Button
          onClick={this.onCloseHandler}
          className={'custom__btn'}
          outlined
          size={'is-medium'}
          content={` <  Back `}
          // onClick
        ></Button>
        <Button
          size={'is-medium'}
          onClick={this.onCloseHandler1}
          className={'custom__btn custom-width'}
          content={' Continue '}
        ></Button>
      </div>
      // </div>
    );

    return (
      <Modal
        theme={theme}
        // onCloseHandler={this.onCloseHandler}
        footer={footerDom}
        hideClose
        width={50}
        isMobileFullLayout={innerWidth <= 1023}
        contentCustomClass="u_bor_rad_top_6px"
      >
        <div className={`product-detail ${theme}`}>
          <div className="product-detail__content">
            <div className="product-detail__header">
              <>
                <div className="product-detail__name position-center">
                  <span className="product-detail__name position-center">
                    {`${wholeData?.[0]?.name || 'Loading...'}`}
                  </span>{' '}
                  <span
                    className="position-center"
                    style={{
                      fontSize: '1.5rem'
                    }}
                  >
                    {`${!!variant_name ? `(${variant_name})` : ''}`}
                  </span>
                </div>
                <div
                  className={`product-detail__image ${
                    !isCollapse ? 'product-detail__image_show' : ''
                  }`}
                >
                  <picture>
                    <source
                      srcSet={`${pdpImageUrl['1x']} 1x, ${pdpImageUrl['2x']} 2x, ${pdpImageUrl['3x']} 3x`}
                      type="image/jpeg/png"
                    />
                    <img
                      src={
                        pdpImageUrl['2x']
                          ? `${pdpImageUrl['2x']}`
                          : process.env.REACT_APP_API_IMAGE_URL +
                            '/products/AE/ml/1xmlPlaceholder134x67AddonSectionjpg'
                      }
                      alt={name}
                      className="product-detail__details-image"
                    />
                  </picture>
                </div>
                <div
                  className={`product-detail__details ${
                    isCollapse
                      ? 'product-detail__details__top__lat test-class-lat'
                      : 'product-detail__details_bottom'
                  }`}
                >
                  <picture>
                    <source
                      srcSet={`${pdpImageUrl['1x']} 1x, ${pdpImageUrl['2x']} 2x, ${pdpImageUrl['3x']} 3x`}
                      type="image/jpeg/png"
                    />
                    <img
                      src={
                        pdpImageUrl['2x']
                          ? `${pdpImageUrl['2x']}`
                          : process.env.REACT_APP_API_IMAGE_URL +
                            '/products/AE/ml/1xmlPlaceholder134x67AddonSectionjpg'
                      }
                      alt={name}
                      className="product-detail__details-image"
                    />
                  </picture>
                </div>
              </>
            </div>
            <div className="product-detail__meal">
              <div className="product-detail__meal-name">Select Size</div>
              <div className="product-detail__meal-list123">
                {showLoader ? (
                  <Loader fitContent="full" theme={theme} />
                ) : (
                  mealListItems
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    productListingData: state.productListing
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getProductAddonDetailData: payloadData =>
      dispatch(getProductAddonDetail(payloadData))
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductDetailPage)
);
